
/**
 * The text widget layouts

!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

  PLEASE READ THIS!!!!

  When/if adding new layout (or removing old one) please adjust maxLayouts in text widget config (in ValuationWidgetsL3.json) !!

!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
*/
export const textWidgetLayouts = [
  { id: 1, description: 'Competitor Overview Comment', widgetName: 'CompetitorOverviewComment' }
  , { id: 7, description: 'Investment Comparables Comment', widgetName: 'InvestmentComparablesComment' }
  , { id: 24, description: 'Leasing Comparables Comment', widgetName: 'LeasingComparablesComment' }
  , { id: 8, description: 'Loan Security Purpose', widgetName: 'LoanSecurityPurpose' }
  , { id: 17, description: 'Logo', widgetName: 'Logo' }
  , { id: 2, description: 'Macro Location', widgetName: 'MacroLocation' }
  , { id: 3, description: 'Micro Location', widgetName: 'MicroLocation' }
  , { id: 4, description: 'Property Description', widgetName: 'PropertyDescription' }
  , { id: 5, description: 'Rent Roll Comment', widgetName: 'RentRollComment' }
  , { id: 35, description: 'Signature 1', widgetName: 'Signature1' }
  , { id: 36, description: 'Signature 2', widgetName: 'Signature2' }
  , { id: 37, description: 'Signature 3', widgetName: 'Signature3' }
  , { id: 38, description: 'Significant Appraisal Assistance', widgetName: 'SignificantAppraisalAssistance' }
  , { id: 6, description: 'Valuation Assumptions Comment', widgetName: 'ValuationAssumptionsComment' }
  , { id: 9, description: 'Valuation Comment MV', widgetName: 'ValuationCommentMarketValue' }
  , { id: 16, description: 'Valuation Comment VPV', widgetName: 'ValuationCommentVacantPossessionValue' }
  , { id: 18, description: 'Valuation Comment Scenario 1', widgetName: 'ValuationCommentScenario1' }
  , { id: 19, description: 'Valuation Comment Scenario 2', widgetName: 'ValuationCommentScenario2' }



  , { id: 10, description: 'Text Dummy 1', widgetName: 'TextDummys1' }
  , { id: 11, description: 'Text Dummy 2', widgetName: 'TextDummys2' }
  , { id: 12, description: 'Text Dummy 3', widgetName: 'TextDummys3' }
  , { id: 13, description: 'Text Dummy 4', widgetName: 'TextDummys4' }
  , { id: 14, description: 'Text Dummy 5', widgetName: 'TextDummys5' }
  , { id: 15, description: 'Text Dummy 6', widgetName: 'TextDummys6' }
  , { id: 20, description: 'Text Dummy 7', widgetName: 'TextDummys7' }
  , { id: 21, description: 'Text Dummy 8', widgetName: 'TextDummys8' }
  , { id: 22, description: 'Text Dummy 9', widgetName: 'TextDummys9' }
  , { id: 23, description: 'Text Dummy 10', widgetName: 'TextDummys10' }
  , { id: 25, description: 'Text Dummy 11', widgetName: 'TextDummys11' }
  , { id: 26, description: 'Text Dummy 12', widgetName: 'TextDummys12' }
  , { id: 27, description: 'Text Dummy 13', widgetName: 'TextDummys13' }
  , { id: 28, description: 'Text Dummy 14', widgetName: 'TextDummys14' }
  , { id: 29, description: 'Text Dummy 15', widgetName: 'TextDummys15' }
  , { id: 30, description: 'Text Dummy 16', widgetName: 'TextDummys16' }
  , { id: 31, description: 'Text Dummy 17', widgetName: 'TextDummys17' }
  , { id: 32, description: 'Text Dummy 18', widgetName: 'TextDummys18' }
  , { id: 33, description: 'Text Dummy 19', widgetName: 'TextDummys19' }
  , { id: 34, description: 'Text Dummy 20', widgetName: 'TextDummys20' }


  , { id: 39, description: 'Text Dummy 21', widgetName: 'TextDummys21' }
  , { id: 40, description: 'Text Dummy 22', widgetName: 'TextDummys22' }
  , { id: 41, description: 'Text Dummy 23', widgetName: 'TextDummys23' }
  , { id: 42, description: 'Text Dummy 24', widgetName: 'TextDummys24' }
  , { id: 43, description: 'Text Dummy 25', widgetName: 'TextDummys25' }
  , { id: 44, description: 'Text Dummy 26', widgetName: 'TextDummys26' }
  , { id: 45, description: 'Text Dummy 27', widgetName: 'TextDummys27' }
  , { id: 46, description: 'Text Dummy 28', widgetName: 'TextDummys28' }
  , { id: 47, description: 'Text Dummy 29', widgetName: 'TextDummys29' }
  , { id: 48, description: 'Text Dummy 30', widgetName: 'TextDummys30' }
  , { id: 49, description: 'Text Dummy 31', widgetName: 'TextDummys31' }
  , { id: 50, description: 'Text Dummy 32', widgetName: 'TextDummys32' }
  , { id: 51, description: 'Text Dummy 33', widgetName: 'TextDummys33' }
  , { id: 52, description: 'Text Dummy 34', widgetName: 'TextDummys34' }
  , { id: 53, description: 'Text Dummy 35', widgetName: 'TextDummys35' }
  , { id: 54, description: 'Text Dummy 36', widgetName: 'TextDummys36' }
  , { id: 55, description: 'Text Dummy 37', widgetName: 'TextDummys37' }
  , { id: 56, description: 'Text Dummy 38', widgetName: 'TextDummys38' }
  , { id: 57, description: 'Text Dummy 39', widgetName: 'TextDummys39' }
  , { id: 58, description: 'Text Dummy 40', widgetName: 'TextDummys40' }
  , { id: 59, description: 'Text Dummy 41', widgetName: 'TextDummys41' }
  , { id: 60, description: 'Text Dummy 42', widgetName: 'TextDummys42' }
  , { id: 61, description: 'Text Dummy 43', widgetName: 'TextDummys43' }
  , { id: 62, description: 'Text Dummy 44', widgetName: 'TextDummys44' }
  , { id: 63, description: 'Text Dummy 45', widgetName: 'TextDummys45' }
  , { id: 64, description: 'Text Dummy 46', widgetName: 'TextDummys46' }
  , { id: 65, description: 'Text Dummy 47', widgetName: 'TextDummys47' }
  , { id: 66, description: 'Text Dummy 48', widgetName: 'TextDummys48' }
  , { id: 67, description: 'Text Dummy 49', widgetName: 'TextDummys49' }
  , { id: 68, description: 'Text Dummy 50', widgetName: 'TextDummys50' }
  , { id: 69, description: 'Text Dummy 51', widgetName: 'TextDummys51' }
  , { id: 70, description: 'Text Dummy 52', widgetName: 'TextDummys52' }
  , { id: 71, description: 'Text Dummy 53', widgetName: 'TextDummys53' }
  , { id: 72, description: 'Text Dummy 54', widgetName: 'TextDummys54' }
  , { id: 73, description: 'Text Dummy 55', widgetName: 'TextDummys55' }
  , { id: 74, description: 'Text Dummy 56', widgetName: 'TextDummys56' }
  , { id: 75, description: 'Text Dummy 57', widgetName: 'TextDummys57' }
  , { id: 76, description: 'Text Dummy 58', widgetName: 'TextDummys58' }
  , { id: 77, description: 'Text Dummy 59', widgetName: 'TextDummys59' }
  , { id: 78, description: 'Text Dummy 60', widgetName: 'TextDummys60' }
  , { id: 79, description: 'Text Dummy 61', widgetName: 'TextDummys61' }
  , { id: 80, description: 'Text Dummy 62', widgetName: 'TextDummys62' }
  , { id: 81, description: 'Text Dummy 63', widgetName: 'TextDummys63' }
  , { id: 82, description: 'Text Dummy 64', widgetName: 'TextDummys64' }
  , { id: 83, description: 'Text Dummy 65', widgetName: 'TextDummys65' }
  , { id: 84, description: 'Text Dummy 66', widgetName: 'TextDummys66' }
  , { id: 85, description: 'Text Dummy 67', widgetName: 'TextDummys67' }
  , { id: 86, description: 'Text Dummy 68', widgetName: 'TextDummys68' }
  , { id: 87, description: 'Text Dummy 69', widgetName: 'TextDummys69' }
  , { id: 88, description: 'Text Dummy 70', widgetName: 'TextDummys70' }
  , { id: 89, description: 'Text Dummy 71', widgetName: 'TextDummys71' }
  , { id: 90, description: 'Text Dummy 72', widgetName: 'TextDummys72' }
  , { id: 91, description: 'Text Dummy 73', widgetName: 'TextDummys73' }
  , { id: 92, description: 'Text Dummy 74', widgetName: 'TextDummys74' }
  , { id: 93, description: 'Text Dummy 75', widgetName: 'TextDummys75' }
  , { id: 94, description: 'Text Dummy 76', widgetName: 'TextDummys76' }
  , { id: 95, description: 'Text Dummy 77', widgetName: 'TextDummys77' }
  , { id: 96, description: 'Text Dummy 78', widgetName: 'TextDummys78' }
  , { id: 97, description: 'Text Dummy 79', widgetName: 'TextDummys79' }
  , { id: 98, description: 'Text Dummy 80', widgetName: 'TextDummys80' }
  , { id: 99, description: 'Text Dummy 81', widgetName: 'TextDummys81' }
  , { id: 100, description: 'Text Dummy 82', widgetName: 'TextDummys82' }
  , { id: 101, description: 'Text Dummy 83', widgetName: 'TextDummys83' }
  , { id: 102, description: 'Text Dummy 84', widgetName: 'TextDummys84' }
  , { id: 103, description: 'Text Dummy 85', widgetName: 'TextDummys85' }
  , { id: 104, description: 'Text Dummy 86', widgetName: 'TextDummys86' }
  , { id: 105, description: 'Text Dummy 87', widgetName: 'TextDummys87' }
  , { id: 106, description: 'Text Dummy 88', widgetName: 'TextDummys88' }
  , { id: 107, description: 'Text Dummy 89', widgetName: 'TextDummys89' }
  , { id: 108, description: 'Text Dummy 90', widgetName: 'TextDummys90' }
  , { id: 109, description: 'Text Dummy 91', widgetName: 'TextDummys91' }
  , { id: 110, description: 'Text Dummy 92', widgetName: 'TextDummys92' }
  , { id: 111, description: 'Text Dummy 93', widgetName: 'TextDummys93' }
  , { id: 112, description: 'Text Dummy 94', widgetName: 'TextDummys94' }
  , { id: 113, description: 'Text Dummy 95', widgetName: 'TextDummys95' }
  , { id: 114, description: 'Text Dummy 96', widgetName: 'TextDummys96' }
  , { id: 115, description: 'Text Dummy 97', widgetName: 'TextDummys97' }
  , { id: 116, description: 'Text Dummy 98', widgetName: 'TextDummys98' }
  , { id: 117, description: 'Text Dummy 99', widgetName: 'TextDummys99' }
  , { id: 118, description: 'Text Dummy 100', widgetName: 'TextDummys100' }
  , { id: 119, description: 'Text Dummy 101', widgetName: 'TextDummys101' }
  , { id: 120, description: 'Text Dummy 102', widgetName: 'TextDummys102' }
  , { id: 121, description: 'Text Dummy 103', widgetName: 'TextDummys103' }
  , { id: 122, description: 'Text Dummy 104', widgetName: 'TextDummys104' }
  , { id: 123, description: 'Text Dummy 105', widgetName: 'TextDummys105' }
  , { id: 124, description: 'Text Dummy 106', widgetName: 'TextDummys106' }
  , { id: 125, description: 'Text Dummy 107', widgetName: 'TextDummys107' }
  , { id: 126, description: 'Text Dummy 108', widgetName: 'TextDummys108' }
  , { id: 127, description: 'Text Dummy 109', widgetName: 'TextDummys109' }
  , { id: 128, description: 'Text Dummy 110', widgetName: 'TextDummys110' }
  , { id: 129, description: 'Text Dummy 111', widgetName: 'TextDummys111' }
  , { id: 130, description: 'Text Dummy 112', widgetName: 'TextDummys112' }
  , { id: 131, description: 'Text Dummy 113', widgetName: 'TextDummys113' }
  , { id: 132, description: 'Text Dummy 114', widgetName: 'TextDummys114' }
  , { id: 133, description: 'Text Dummy 115', widgetName: 'TextDummys115' }
  , { id: 134, description: 'Text Dummy 116', widgetName: 'TextDummys116' }
  , { id: 135, description: 'Text Dummy 117', widgetName: 'TextDummys117' }
  , { id: 136, description: 'Text Dummy 118', widgetName: 'TextDummys118' }
  , { id: 137, description: 'Text Dummy 119', widgetName: 'TextDummys119' }
  , { id: 138, description: 'Text Dummy 120', widgetName: 'TextDummys120' }
  , { id: 139, description: 'Text Dummy 121', widgetName: 'TextDummys121' }
  , { id: 140, description: 'Text Dummy 122', widgetName: 'TextDummys122' }
  , { id: 141, description: 'Text Dummy 123', widgetName: 'TextDummys123' }
  , { id: 142, description: 'Text Dummy 124', widgetName: 'TextDummys124' }
  , { id: 143, description: 'Text Dummy 125', widgetName: 'TextDummys125' }
  , { id: 144, description: 'Text Dummy 126', widgetName: 'TextDummys126' }
  , { id: 145, description: 'Text Dummy 127', widgetName: 'TextDummys127' }
  , { id: 146, description: 'Text Dummy 128', widgetName: 'TextDummys128' }
  , { id: 147, description: 'Text Dummy 129', widgetName: 'TextDummys129' }
  , { id: 148, description: 'Text Dummy 130', widgetName: 'TextDummys130' }
  , { id: 149, description: 'Text Dummy 131', widgetName: 'TextDummys131' }
  , { id: 150, description: 'Text Dummy 132', widgetName: 'TextDummys132' }
  , { id: 151, description: 'Text Dummy 133', widgetName: 'TextDummys133' }
  , { id: 152, description: 'Text Dummy 134', widgetName: 'TextDummys134' }
  , { id: 153, description: 'Text Dummy 135', widgetName: 'TextDummys135' }
  , { id: 154, description: 'Text Dummy 136', widgetName: 'TextDummys136' }
  , { id: 155, description: 'Text Dummy 137', widgetName: 'TextDummys137' }
  , { id: 156, description: 'Text Dummy 138', widgetName: 'TextDummys138' }
  , { id: 157, description: 'Text Dummy 139', widgetName: 'TextDummys139' }
  , { id: 158, description: 'Text Dummy 140', widgetName: 'TextDummys140' }
  , { id: 159, description: 'Text Dummy 141', widgetName: 'TextDummys141' }
  , { id: 160, description: 'Text Dummy 142', widgetName: 'TextDummys142' }
  , { id: 161, description: 'Text Dummy 143', widgetName: 'TextDummys143' }
  , { id: 162, description: 'Text Dummy 144', widgetName: 'TextDummys144' }
  , { id: 163, description: 'Text Dummy 145', widgetName: 'TextDummys145' }
  , { id: 164, description: 'Text Dummy 146', widgetName: 'TextDummys146' }
  , { id: 165, description: 'Text Dummy 147', widgetName: 'TextDummys147' }
  , { id: 166, description: 'Text Dummy 148', widgetName: 'TextDummys148' }
  , { id: 167, description: 'Text Dummy 149', widgetName: 'TextDummys149' }
  , { id: 168, description: 'Text Dummy 150', widgetName: 'TextDummys150' }
  , { id: 169, description: 'Text Dummy 151', widgetName: 'TextDummys151' }
  , { id: 170, description: 'Text Dummy 152', widgetName: 'TextDummys152' }
  , { id: 171, description: 'Text Dummy 153', widgetName: 'TextDummys153' }
  , { id: 172, description: 'Text Dummy 154', widgetName: 'TextDummys154' }
  , { id: 173, description: 'Text Dummy 155', widgetName: 'TextDummys155' }
  , { id: 174, description: 'Text Dummy 156', widgetName: 'TextDummys156' }
  , { id: 175, description: 'Text Dummy 157', widgetName: 'TextDummys157' }
  , { id: 176, description: 'Text Dummy 158', widgetName: 'TextDummys158' }
  , { id: 177, description: 'Text Dummy 159', widgetName: 'TextDummys159' }
  , { id: 178, description: 'Text Dummy 160', widgetName: 'TextDummys160' }
  , { id: 179, description: 'Text Dummy 161', widgetName: 'TextDummys161' }
  , { id: 180, description: 'Text Dummy 162', widgetName: 'TextDummys162' }
  , { id: 181, description: 'Text Dummy 163', widgetName: 'TextDummys163' }
  , { id: 182, description: 'Text Dummy 164', widgetName: 'TextDummys164' }
  , { id: 183, description: 'Text Dummy 165', widgetName: 'TextDummys165' }
  , { id: 184, description: 'Text Dummy 166', widgetName: 'TextDummys166' }
  , { id: 185, description: 'Text Dummy 167', widgetName: 'TextDummys167' }
  , { id: 186, description: 'Text Dummy 168', widgetName: 'TextDummys168' }
  , { id: 187, description: 'Text Dummy 169', widgetName: 'TextDummys169' }
  , { id: 188, description: 'Text Dummy 170', widgetName: 'TextDummys170' }
  , { id: 189, description: 'Text Dummy 171', widgetName: 'TextDummys171' }
  , { id: 190, description: 'Text Dummy 172', widgetName: 'TextDummys172' }
  , { id: 191, description: 'Text Dummy 173', widgetName: 'TextDummys173' }
  , { id: 192, description: 'Text Dummy 174', widgetName: 'TextDummys174' }
  , { id: 193, description: 'Text Dummy 175', widgetName: 'TextDummys175' }
  , { id: 194, description: 'Text Dummy 176', widgetName: 'TextDummys176' }
  , { id: 195, description: 'Text Dummy 177', widgetName: 'TextDummys177' }
  , { id: 196, description: 'Text Dummy 178', widgetName: 'TextDummys178' }
  , { id: 197, description: 'Text Dummy 179', widgetName: 'TextDummys179' }
  , { id: 198, description: 'Text Dummy 180', widgetName: 'TextDummys180' }
  , { id: 199, description: 'Text Dummy 181', widgetName: 'TextDummys181' }
  , { id: 200, description: 'Text Dummy 182', widgetName: 'TextDummys182' }
  , { id: 201, description: 'Text Dummy 183', widgetName: 'TextDummys183' }
  , { id: 202, description: 'Text Dummy 184', widgetName: 'TextDummys184' }
  , { id: 203, description: 'Text Dummy 185', widgetName: 'TextDummys185' }
  , { id: 204, description: 'Text Dummy 186', widgetName: 'TextDummys186' }
  , { id: 205, description: 'Text Dummy 187', widgetName: 'TextDummys187' }
  , { id: 206, description: 'Text Dummy 188', widgetName: 'TextDummys188' }
  , { id: 207, description: 'Text Dummy 189', widgetName: 'TextDummys189' }
  , { id: 208, description: 'Text Dummy 190', widgetName: 'TextDummys190' }
  , { id: 209, description: 'Text Dummy 191', widgetName: 'TextDummys191' }
  , { id: 210, description: 'Text Dummy 192', widgetName: 'TextDummys192' }
  , { id: 211, description: 'Text Dummy 193', widgetName: 'TextDummys193' }
  , { id: 212, description: 'Text Dummy 194', widgetName: 'TextDummys194' }
  , { id: 213, description: 'Text Dummy 195', widgetName: 'TextDummys195' }
  , { id: 214, description: 'Text Dummy 196', widgetName: 'TextDummys196' }
  , { id: 215, description: 'Text Dummy 197', widgetName: 'TextDummys197' }
  , { id: 216, description: 'Text Dummy 198', widgetName: 'TextDummys198' }
  , { id: 217, description: 'Text Dummy 199', widgetName: 'TextDummys199' }
  , { id: 218, description: 'Text Dummy 200', widgetName: 'TextDummys200' }
  , { id: 219, description: 'Text Dummy 201', widgetName: 'TextDummys201' }
  , { id: 220, description: 'Text Dummy 202', widgetName: 'TextDummys202' }
  , { id: 221, description: 'Text Dummy 203', widgetName: 'TextDummys203' }
  , { id: 222, description: 'Text Dummy 204', widgetName: 'TextDummys204' }
  , { id: 223, description: 'Text Dummy 205', widgetName: 'TextDummys205' }
  , { id: 224, description: 'Text Dummy 206', widgetName: 'TextDummys206' }
  , { id: 225, description: 'Text Dummy 207', widgetName: 'TextDummys207' }
  , { id: 226, description: 'Text Dummy 208', widgetName: 'TextDummys208' }
  , { id: 227, description: 'Text Dummy 209', widgetName: 'TextDummys209' }
  , { id: 228, description: 'Text Dummy 210', widgetName: 'TextDummys210' }
  , { id: 229, description: 'Text Dummy 211', widgetName: 'TextDummys211' }
  , { id: 230, description: 'Text Dummy 212', widgetName: 'TextDummys212' }
  , { id: 231, description: 'Text Dummy 213', widgetName: 'TextDummys213' }
  , { id: 232, description: 'Text Dummy 214', widgetName: 'TextDummys214' }
  , { id: 233, description: 'Text Dummy 215', widgetName: 'TextDummys215' }
  , { id: 234, description: 'Text Dummy 216', widgetName: 'TextDummys216' }
  , { id: 235, description: 'Text Dummy 217', widgetName: 'TextDummys217' }
  , { id: 236, description: 'Text Dummy 218', widgetName: 'TextDummys218' }
  , { id: 237, description: 'Text Dummy 219', widgetName: 'TextDummys219' }
  , { id: 238, description: 'Text Dummy 220', widgetName: 'TextDummys220' }
  , { id: 239, description: 'Text Dummy 221', widgetName: 'TextDummys221' }
  , { id: 240, description: 'Text Dummy 222', widgetName: 'TextDummys222' }
  , { id: 241, description: 'Text Dummy 223', widgetName: 'TextDummys223' }
  , { id: 242, description: 'Text Dummy 224', widgetName: 'TextDummys224' }
  , { id: 243, description: 'Text Dummy 225', widgetName: 'TextDummys225' }
  , { id: 244, description: 'Text Dummy 226', widgetName: 'TextDummys226' }
  , { id: 245, description: 'Text Dummy 227', widgetName: 'TextDummys227' }
  , { id: 246, description: 'Text Dummy 228', widgetName: 'TextDummys228' }
  , { id: 247, description: 'Text Dummy 229', widgetName: 'TextDummys229' }
  , { id: 248, description: 'Text Dummy 230', widgetName: 'TextDummys230' }
  , { id: 249, description: 'Text Dummy 231', widgetName: 'TextDummys231' }
  , { id: 250, description: 'Text Dummy 232', widgetName: 'TextDummys232' }
  , { id: 251, description: 'Text Dummy 233', widgetName: 'TextDummys233' }
  , { id: 252, description: 'Text Dummy 234', widgetName: 'TextDummys234' }
  , { id: 253, description: 'Text Dummy 235', widgetName: 'TextDummys235' }
  , { id: 254, description: 'Text Dummy 236', widgetName: 'TextDummys236' }
  , { id: 255, description: 'Text Dummy 237', widgetName: 'TextDummys237' }
  , { id: 256, description: 'Text Dummy 238', widgetName: 'TextDummys238' }
  , { id: 257, description: 'Text Dummy 239', widgetName: 'TextDummys239' }
  , { id: 258, description: 'Text Dummy 240', widgetName: 'TextDummys240' }
  , { id: 259, description: 'Text Dummy 241', widgetName: 'TextDummys241' }
  , { id: 260, description: 'Text Dummy 242', widgetName: 'TextDummys242' }
  , { id: 261, description: 'Text Dummy 243', widgetName: 'TextDummys243' }
  , { id: 262, description: 'Text Dummy 244', widgetName: 'TextDummys244' }
  , { id: 263, description: 'Text Dummy 245', widgetName: 'TextDummys245' }
  , { id: 264, description: 'Text Dummy 246', widgetName: 'TextDummys246' }
  , { id: 265, description: 'Text Dummy 247', widgetName: 'TextDummys247' }
  , { id: 266, description: 'Text Dummy 248', widgetName: 'TextDummys248' }
  , { id: 267, description: 'Text Dummy 249', widgetName: 'TextDummys249' }
  , { id: 268, description: 'Text Dummy 250', widgetName: 'TextDummys250' }
  , { id: 269, description: 'Text Dummy 251', widgetName: 'TextDummys251' }
  , { id: 270, description: 'Text Dummy 252', widgetName: 'TextDummys252' }
  , { id: 271, description: 'Text Dummy 253', widgetName: 'TextDummys253' }
  , { id: 272, description: 'Text Dummy 254', widgetName: 'TextDummys254' }
  , { id: 273, description: 'Text Dummy 255', widgetName: 'TextDummys255' }
  , { id: 274, description: 'Text Dummy 256', widgetName: 'TextDummys256' }
  , { id: 275, description: 'Text Dummy 257', widgetName: 'TextDummys257' }
  , { id: 276, description: 'Text Dummy 258', widgetName: 'TextDummys258' }
  , { id: 277, description: 'Text Dummy 259', widgetName: 'TextDummys259' }
  , { id: 278, description: 'Text Dummy 260', widgetName: 'TextDummys260' }
  , { id: 279, description: 'Text Dummy 261', widgetName: 'TextDummys261' }
  , { id: 280, description: 'Text Dummy 262', widgetName: 'TextDummys262' }
  , { id: 281, description: 'Text Dummy 263', widgetName: 'TextDummys263' }
  , { id: 282, description: 'Text Dummy 264', widgetName: 'TextDummys264' }
  , { id: 283, description: 'Text Dummy 265', widgetName: 'TextDummys265' }
  , { id: 284, description: 'Text Dummy 266', widgetName: 'TextDummys266' }
  , { id: 285, description: 'Text Dummy 267', widgetName: 'TextDummys267' }
  , { id: 286, description: 'Text Dummy 268', widgetName: 'TextDummys268' }
  , { id: 287, description: 'Text Dummy 269', widgetName: 'TextDummys269' }
  , { id: 288, description: 'Text Dummy 270', widgetName: 'TextDummys270' }
  , { id: 289, description: 'Text Dummy 271', widgetName: 'TextDummys271' }
  , { id: 290, description: 'Text Dummy 272', widgetName: 'TextDummys272' }
  , { id: 291, description: 'Text Dummy 273', widgetName: 'TextDummys273' }
  , { id: 292, description: 'Text Dummy 274', widgetName: 'TextDummys274' }
  , { id: 293, description: 'Text Dummy 275', widgetName: 'TextDummys275' }
  , { id: 294, description: 'Text Dummy 276', widgetName: 'TextDummys276' }
  , { id: 295, description: 'Text Dummy 277', widgetName: 'TextDummys277' }
  , { id: 296, description: 'Text Dummy 278', widgetName: 'TextDummys278' }
  , { id: 297, description: 'Text Dummy 279', widgetName: 'TextDummys279' }
  , { id: 298, description: 'Text Dummy 280', widgetName: 'TextDummys280' }
  , { id: 299, description: 'Text Dummy 281', widgetName: 'TextDummys281' }
  , { id: 300, description: 'Text Dummy 282', widgetName: 'TextDummys282' }
  , { id: 301, description: 'Text Dummy 283', widgetName: 'TextDummys283' }
  , { id: 302, description: 'Text Dummy 284', widgetName: 'TextDummys284' }
  , { id: 303, description: 'Text Dummy 285', widgetName: 'TextDummys285' }
  , { id: 304, description: 'Text Dummy 286', widgetName: 'TextDummys286' }
  , { id: 305, description: 'Text Dummy 287', widgetName: 'TextDummys287' }
  , { id: 306, description: 'Text Dummy 288', widgetName: 'TextDummys288' }
  , { id: 307, description: 'Text Dummy 289', widgetName: 'TextDummys289' }
  , { id: 308, description: 'Text Dummy 290', widgetName: 'TextDummys290' }
  , { id: 309, description: 'Text Dummy 291', widgetName: 'TextDummys291' }
  , { id: 310, description: 'Text Dummy 292', widgetName: 'TextDummys292' }
  , { id: 311, description: 'Text Dummy 293', widgetName: 'TextDummys293' }
  , { id: 312, description: 'Text Dummy 294', widgetName: 'TextDummys294' }
  , { id: 313, description: 'Text Dummy 295', widgetName: 'TextDummys295' }
  , { id: 314, description: 'Text Dummy 296', widgetName: 'TextDummys296' }
  , { id: 315, description: 'Text Dummy 297', widgetName: 'TextDummys297' }
  , { id: 316, description: 'Text Dummy 298', widgetName: 'TextDummys298' }
  , { id: 317, description: 'Text Dummy 299', widgetName: 'TextDummys299' }
  , { id: 318, description: 'Text Dummy 300', widgetName: 'TextDummys300' }

];
